/** Which ends of a run of days really belong to this week row. */
export type WeekBreakEdges = Readonly<{ isEnd: boolean; isStart: boolean }>

/**
 * What the squared-off edge says, for anyone who cannot see it.
 *
 * It is added to the item's own name rather than given to a mark of its own,
 * so the two are read as one thing: "Summer launch, continues into the next
 * week".
 */
export const weekBreakLabel = ({ isEnd, isStart }: WeekBreakEdges): string =>
  `${isStart ? '' : ', continues from the previous week'}${
    isEnd ? '' : ', continues into the next week'
  }`
